import ExcelJS from 'exceljs/dist/exceljs.min.js';

import type { SciReport } from '../@types/SciContactImport';
import { formatOfficer } from '../@types/SciContactImport';

/**
 * Rows to send back to the client: the contact was not written, unless the row only carried
 * a "Client en gestion" answer (no name nor email) and that answer was taken.
 */
export const sciRowsToComplete = (report: SciReport): SciReport['rows'] => report.rows.filter((row) => (
  row.outcome !== 'imported' && row.outcome !== 'identical'
  && !(row.status === 'no_signal' && row.managedOutcome !== null && row.managedOutcome !== undefined)
));

/**
 * Rows of an applied SCI contacts import that were not written, in the SCI export format
 * plus "Motif" and "Dirigeants connus", so the client can fix them and send the file back.
 */
export const downloadSciRefusalExcel = async(report: SciReport, companyName: string): Promise<number> => {
  const rows = sciRowsToComplete(report);

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet('SCIs à compléter');
  const headers = [...report.headers, 'Motif', 'Dirigeants connus'];
  sheet.addRow(headers);
  sheet.getRow(1).font = { bold: true };

  rows.forEach((row) => {
    sheet.addRow([
      ...report.headers.map((header) => row.raw[header] ?? ''),
      row.motif ?? '',
      row.officers.map((officer) => `${formatOfficer(officer)} (${officer.role})`).join(' | '),
    ]);
  });

  sheet.columns.forEach((column, index) => {
    const header = headers[index] ?? '';
    column.width = Math.min(Math.max(header.length + 2, 14), 60);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = `SCIs_a_completer_${companyName.replaceAll(' ', '-')}_${new Date().toISOString().slice(0, 10)}.xlsx`;
  link.click();

  return rows.length;
};
